/** @jsx isolateComponent */
import React from 'react';
import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * Optional `aria-label` to apply to the list. Typically this should
   * be handled by a headline that renders above `InteractiveTags`.
   */
  ariaLabel?: string;
  /**
   * The `InteractiveTag`s to group together.
   */
  children: React.ReactNode;
};

const Styles = labelStyles('InteractiveTags', {
  root: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // TODO: Switch to Flexbox 'gap' when Safari supports it
    // and remove 'Styles.item' entirely.
    margin-bottom: -10px;
  `,
  item: css`
    margin-bottom: 10px;
    &:not(:last-child) {
      margin-right: 10px;
    }
  `,
});

/**
 * Renders a grouping of `InteractiveTag` components.
 */
export const InteractiveTags = (props: Props) => {
  const tags = React.Children.toArray(props.children)
    .filter(Boolean)
    .map((child, i) => {
      // Using `i` for `key` since there isn't a good alternative.
      return (
        <li css={Styles.item} key={i}>
          {child}
        </li>
      );
    });
  return (
    <ul aria-label={props.ariaLabel} css={Styles.root}>
      {tags}
    </ul>
  );
};
